
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

@Component
export default class SearchProject extends Vue {
    @Getter projectList: any;
    @Prop() chooseProjectVisible: boolean;
    @Prop() confirmSelectedProject: Function;
    @Action('getProjectList') getProjectList: Function;

    searchVal: string = '';
    selectedProject: {[key: string]: any} = {};

    // 关闭弹窗
    handleClose() {
        // 清空表格数据
        this.closeVisible();
    }

    setCurrent(row: number) {
        (this.$refs.singleTable as any).setCurrentRow(row);
    }

    handleCurrentChange(val: {[key: string]: any}) {
        this.selectedProject = val;
    }

    // 关闭窗口
    closeVisible() {
        this.searchVal = '';
        this.selectedProject = {};
        this.$emit('closeChooseProjectVisible', true);
    }

    handleSelect(key: any) {
        this.searchVal = '';
        this.$emit('closeChooseProjectVisible', true);
    }

    // 确认选择的条目
    confirmbtn() {
        this.confirmSelectedProject(this.selectedProject);
    }

    // 确认搜索
    onSubmit() {
        this.getProjectList({keyword: this.searchVal, isPage: false, top: 100});
    }

}
